import { IApplePayButtonFactory } from "../services/button/IApplePayButtonFactory";
import { APPLE_PAY_BUTTON_ATTRIBUTE } from "../services/button/ApplePayButtonProperties";

export class MockedApplePayButtonFactory implements IApplePayButtonFactory {
  create(label: string, style: string): HTMLElement {
    const button = document.createElement("button");
    button.setAttribute(APPLE_PAY_BUTTON_ATTRIBUTE, "true");
    button.textContent = "Buy with Apple Pay";
    button.style.backgroundColor = "black";
    button.style.color = "white";
    button.style.padding = "10px 20px";
    button.style.borderRadius = "20px";
    button.style.border = "none";
    button.style.fontFamily = "Arial, sans-serif";
    button.style.fontSize = "16px";
    button.style.cursor = "pointer";
    return button;
  }
}
